// How far ahead of the viewport an element counts as near it: far enough for what it loads to be
// there by the time it is scrolled into view.
const MARGIN = '200px';

/**
 * Calls back once the element comes near the viewport, then stops watching. An element that is
 * hidden (in a collapsed panel, in a closed dialog) is not near the viewport until it is shown.
 * Returns a function that stops watching sooner, for a component unmounted before that.
 */
export function whenNearViewport(element: Element, callback: () => void): () => void {
    const observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting)) {
            observer.disconnect();
            callback();
        }
    }, {rootMargin: MARGIN});

    observer.observe(element);

    return () => observer.disconnect();
}
